import script from "./AboutTimelineComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutTimelineComponent.vue?vue&type=script&setup=true&lang=js"

import "./AboutTimelineComponent.vue?vue&type=style&index=0&id=a1e5fba6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1e5fba6"]])

export default __exports__